import { render, staticRenderFns } from "./FormularioCultura.vue?vue&type=template&id=f469a3b2&scoped=true&"
import script from "./FormularioCultura.vue?vue&type=script&lang=ts&"
export * from "./FormularioCultura.vue?vue&type=script&lang=ts&"
import style0 from "./FormularioCultura.vue?vue&type=style&index=0&id=f469a3b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f469a3b2",
  null
  
)

export default component.exports